import { UPLOADS, ebook, pdf } from '@/content/ebookBuilder'
import type { Ebook } from '@/content/ebookBuilder'

export const added: Ebook = ebook(
  // Confirmed, and NOT what the title rule derives: the reference screenshots
  // for this book's page came from
  // `digitopia.co/impact-labs/ebooks/mastering-communication-for-transformation/`
  // on 2026-08-28 (the filenames carry the address), so the address is the
  // part after the colon and `the-language-of-change` was a wrong guess.
  'mastering-communication-for-transformation',
  'The Language of Change: Mastering Communication for Transformation Success',
  `${UPLOADS}/2025/07/the-language-of-change-mastering-communication-for-transformation-success-400x400.jpg`,
  {
    confirmed: true,
    download: pdf(
      '50164e94-2178-4740-a318-0e941e4174ce-Mastering Communication for Transformation Success.pdf',
    ),
    // Designed as its own written page on 2026-08-28 — so the card goes there
    // and `prerender.tsx` skips it, rather than generating the catalogue
    // template over the top of it.
    href: '/en/impact-labs/ebooks/mastering-communication-for-transformation',
  },
)

/** Its place in the library grid — the order the imported index listed them. */
export const order = 1
